<template>
  <el-row :gutter="12" type="flex" align="bottom" class="sharer-rate-override">
    <el-col :sm="24" :md="16">
      <select-sharer-rates
        ref="rateSelect"
        v-model="selectedRateId"
        label="Sharer Rate"
        :placeholder="placeholder"
        :sharer-id="sharerId"
        :size="size"
        :disabled="disabled"
        clearable
        no-data-text="No rates for this sharer"
        @change="onRateChange" />
    </el-col>
    <el-col :sm="24" :md="8">
      <el-form-item v-if="selectedRateId">
        <div class="sra-actions">
          <rates-action
            :key="'dup-' + selectedRateId"
            view="sharer"
            :show-range="true"
            :row-data="seedRowData"
            :duplicate="true"
            duplicate-label="Duplicate"
            :publish-only="true"
            :disable-button="disabled || !sharerId"
            @saved="onDuplicateSaved" />
          <rates-action
            :key="'mod-' + selectedRateId"
            view="sharer"
            :show-range="true"
            :row-data="seedRowData"
            label="Modify"
            :publish-only="true"
            :disable-button="disabled || !sharerId"
            @saved="onModifySaved" />
        </div>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>

import RatesAction from '@/components/finance/rates/actions/RatesAction'
import SelectSharerRates from '@/components/atoms/selects/SelectSharerRates'

export default {
  name: 'sharer-rate-override',

  components: {
    RatesAction,
    SelectSharerRates
  },

  props: {
    value: {
      default: null
    },

    sharerId: {
      type: Number,
      default: null
    },

    size: {
      type: String,
      default: 'default'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onRateChange: function (val) {
      this.selectedRateId = val
      // Track the full rate object for seeding the duplicate drawer
      this.selectedRate = this.findRate(val)
      this.seedRowData = this.selectedRate || null
      this.$emit('input', val)
    },

    findRate: function (id) {
      if (!id || !this.$refs.rateSelect) return null
      var opts = this.$refs.rateSelect.options || []
      return opts.find(function (o) { return o.id === id }) || null
    },

    onDuplicateSaved: function (newRate) {
      if (!newRate || !newRate.id) return
      // Inject into the select's local options so it appears without re-fetch
      if (this.$refs.rateSelect && typeof this.$refs.rateSelect.addOption === 'function') {
        this.$refs.rateSelect.addOption(newRate)
      }
      // Select the newly created rate
      this.selectedRateId = newRate.id
      this.selectedRate = newRate
      // Re-seed the duplicate drawer so a second Duplicate starts
      // from the rate that was just created, not the previously-selected one.
      this.seedRowData = newRate
      this.$emit('input', newRate.id)
    },

    onModifySaved: function (rate) {
      if (!rate || !rate.id) return
      // Replace the option in the select (keeps the same id, updated tiers)
      if (this.$refs.rateSelect && typeof this.$refs.rateSelect.addOption === 'function') {
        this.$refs.rateSelect.addOption(rate)
      }
      this.selectedRateId = rate.id
      this.selectedRate = rate
      this.seedRowData = rate
      this.$emit('input', rate.id)
    }
  },

  computed: {
    placeholder: function () {
      if (!this.sharerId) {
        return 'Select a sharer first'
      }
      return 'Select a rate (optional)'
    }
  },

  watch: {
    value: function (val) {
      this.selectedRateId = val
    },

    sharerId: function (val, oldVal) {
      if (val === oldVal) return
      this.selectedRateId = null
      this.selectedRate = null
      this.seedRowData = null
      this.$emit('input', null)
    }
  },

  data: function () {
    return {
      selectedRateId: this.value,
      selectedRate: null,
      seedRowData: null
    }
  }
}
</script>

<style scoped>
/* When hosted inside an inline <el-form> (e.g. FinanceSharer "Site Financials"),
   the nested el-form-item defaults to content-width inline-block, leaving the
   rate <el-select> short. Force it to fill its column so the rate name isn't
   truncated. */
.sharer-rate-override ::v-deep .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
}

/* Duplicate + Modify sit side-by-side, aligned to the rate select.
   Each <rates-action> renders a Popup whose root is a block <div>, so without
   this flex wrapper the two buttons stack vertically. */
.sra-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
